import React from "react";
import * as styles from "@styles/Subscription.css";
import type { StateUpdate } from "@ps-bridge/capabilitiesTypes";
import type { ChooseSubscriptionViewProps } from "@ps-bridge/contracts/chooseSubscription";
import * as IO from "@ps-bridge/interop/io";

type PlanSelectorContractProps = Pick<
  ChooseSubscriptionViewProps,
  "subscriptionStatus"
>;

type SelectedPackageValue =
  | string
  | (PlanSelectorContractProps extends { subscriptionStatus: infer Status }
      ? Status
      : never);

type PlanSelectorViewProps = {
  plans: Array<{
    value: string;
    label: string;
    price: string;
    detail: string;
    highlight: string;
  }>;
  selectedPackage: SelectedPackageValue;
  onSelectPlan: StateUpdate<string>;
};

const PlanSelectorView: React.FC<PlanSelectorViewProps> = ({
  plans,
  selectedPackage,
  onSelectPlan,
}) => (
  <div className={styles.mainContainerStyle}>
    {plans.map((plan) => (
      <div key={plan.value} className={styles.radioButtonContainer}>
        <label className={styles.radioLabel}>
          <input
            type="radio"
            name="subscription-plan"
            value={plan.value}
            data-testid={`choose-subscription-plan-${plan.value.toLowerCase()}`}
            checked={selectedPackage === plan.value}
            onChange={() => IO.run(onSelectPlan(plan.value))}
          />
          {plan.label}
        </label>
        <p className={styles.planDetails}>
          {plan.price}
          {" - "}
          {plan.detail}
        </p>
        <p className={styles.planDetails}>
          {plan.highlight}
        </p>
      </div>
    ))}
  </div>
);

export default PlanSelectorView;
